import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DetailDeFacturationPanel from '../panel/DetailDeFacturationPanel';
import EditionAsapDematerialiseePanel from '../panel/EditionAsapDematerialiseePanel';
import NumeroEmpruntPanel from '../panel/NumeroEmpruntPanel';

class ProfilEcritureLieeEmpruntRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.LIEE_EMPRUNT;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.EMPRUNT;
    this.typePiece = TYPE_PIECE.RECETTE.ORDINAIRE;
    this.imputation.articles = ['16'];
    this.panels = [
      ...this.panels,
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DetailDeFacturationPanel(),
      new EditionAsapDematerialiseePanel(),
      new NumeroEmpruntPanel(true),
    ];
  }
}

export default ProfilEcritureLieeEmpruntRecette;
